// extracted by mini-css-extract-plugin
export default {"card":"Card_card__VXs4j","image":"Card_image__ahNOy","link":"Card_link__mggwc","title":"Card_title__I+OBk"};